module.exports = __webpack_public_path__ + "img/restaurant_bodyimage03.8506b7ea.jpg";